import React from 'react';
import { StickyHeader } from '../components/sections/StickyHeader';
import { Hero } from '../components/sections/Hero';
import { SocialProof } from '../components/sections/SocialProof';
import { PainSection } from '../components/sections/PainSection';
import { ProductReveal } from '../components/sections/ProductReveal';
import { Tomos } from '../components/sections/Tomos';
import { Bonuses } from '../components/sections/Bonuses';
import { InnerCircle } from '../components/sections/InnerCircle';
import { Urgency } from '../components/sections/Urgency';
import { Pricing } from '../components/sections/Pricing';
import { Guarantee } from '../components/sections/Guarantee';
import { Testimonials } from '../components/sections/Testimonials';
import { FAQ } from '../components/sections/FAQ';
import { CostOfInaction } from '../components/sections/CostOfInaction';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-canvas text-ink font-sans" data-id="element-358" data-mp="2zjykfnfga6ia">
      <StickyHeader data-id="element-359" data-mp="33k8zrqp4u99t" />
      <main data-id="element-360" data-mp="33jqslz0xman4">
        <Hero data-id="element-361" data-mp="33lbq9xijm9p7" />
        <SocialProof data-id="element-362" data-mp="33ks7kel2jha4" />
        <PainSection data-id="element-363" data-mp="33i5z8cqcsxqu" />
        <ProductReveal data-id="element-364" data-mp="38jvb1ulehffz" />
        <Tomos data-id="element-365" data-mp="38ik980bimhri" />
        <Bonuses data-id="element-366" data-mp="38i26ckucl5am" />
        <InnerCircle data-id="element-367" data-mp="38hilowdbc2sw" />
        <Urgency data-id="element-368" data-mp="3dabrzoofjj73" />
        <Pricing data-id="element-369" data-mp="3davcnd5gslot" />
        <Guarantee data-id="element-370" data-mp="3dbdd6lz5tm2j" />
        <Testimonials data-id="element-371" data-mp="3dbwp9m24pg8n" />
        <FAQ data-id="element-372" data-mp="3dc6ev8j9hldt" />
        <CostOfInaction data-id="element-373" data-mp="3i9ev33kunfcf" />
        <FinalCTA data-id="element-374" data-mp="3ia7v7lpaz6ll" />
      </main>
      <Footer data-id="element-375" data-mp="3i8ww3z6syn0t" />
    </div>;
}